import useSWRImmutable from "swr/immutable";
import type { SearchResponse } from "typesense/lib/Typesense/Documents";

interface UseSearchProps {
	query: string;
}

const useSearch = ({ query }: UseSearchProps) => {
	return useSWRImmutable<SearchResponse<object>>(
		query && `/search?q=${query}`,
		{
			keepPreviousData: true,
		},
	);
};

export default useSearch;
